import gql from 'graphql-tag';

export const COMPLETE_OVERDUE_TASKS_MUTATION = gql`
  mutation CompleteOverdueTasks {
    completeOverdueTasks(input: { placeholder: true }) {
      updated_tasks {
        id
        task_status
        updated_at
        task_completed_time
        task_completed_by_name
      }
      updated_plantings {
        id
        planting_status
        updated_at
      }
      updated_orders {
        id
        order_status
        updated_at
      }
      tasks_created {
        id
      }
      plantings_created {
        id
      }
    }
  }
`;
